// extracted by mini-css-extract-plugin
export default {"info":"BlockWithInfo_info__UgM3y","infoWithBackground":"BlockWithInfo_infoWithBackground__D9dTE"};